import * as React from 'react'
import styled, { css } from 'styled-components'
import GatsbyLink from 'gatsby-link'
import { invert } from 'polished'
import { getBreakpoint } from '../../styles/getBreakpoint'
// @ts-ignore
import * as theme from 'styled-theming'

interface Props {
  to?: string
  arrow?: boolean
  variant?: `default` | `primary`
}

export const Link: React.SFC<Props> = ({ to, variant = `default`, ...props }) => {
  // Any internal link(intended for Gatsby) is assumed to start with exactly one slash
  // and anything else is external.
  const internal = /^\/(?!\/)/.test(to)

  // Use gatsby-link for internal links, and <a> for others
  return internal ? (
    <GatsbyLinkWrapper to={to} variant={variant} {...props} />
  ) : (
    <Wrapper href={to} target="_blank" rel="noopener" variant={variant} {...props} />
  )
}

const colors = {
  link: theme.variants('mode', 'variant', {
    default: {
      light: (props: any) => props.theme.color.black,
      dark: (props: any) => invert(props.theme.color.black),
    },
    primary: {
      light: (props: any) => props.theme.color.primary,
      dark: (props: any) => props.theme.color.primary,
    },
  }),
}

const LINK_CSS = css`
  color: ${colors.link};
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
  ${(props: Props) =>
    props.arrow &&
    css`
		left: 0;
		position: relative;
		transition: all 100ms ease-in-out 250ms;
		&:after {
			background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M5,15.08H24.07L18.64,9.42a1.25,1.25,0,1,1,1.8-1.73l7.46,7.78a1.24,1.24,0,0,1,0,1.73L20.44,25a1.25,1.25,0,0,1-1.8-1.73l5.43-5.67H5a1.25,1.25,0,1,1,0-2.5Z" fill="${
        colors.link
      }"/></svg>');
			content: '';
			display: block;
			height: 20px;
			opacity: 1;
			position: absolute;
			right: -25px;
			top: 50%;
			transform: translateY(-50%);
			transition: all 100ms ease-in-out 250ms;
			width: 20px;
		}
		${getBreakpoint(1)`
			&:after {
				opacity: 0;
				right: 0;
			}
			&:hover {
				left: -10px;
				transition: all 100ms ease-in-out 100ms;
				&:after {
					opacity: 1;
					right: -25px;
					transition: all 100ms ease-in-out 100ms;
				}
			} 
		`}
	`};
`

const Wrapper = styled.a`
  ${LINK_CSS};
`

const GatsbyLinkWrapper = styled(GatsbyLink)`
  ${LINK_CSS};
`

export default Link



// WEBPACK FOOTER //
// ./src/components/Link/index.tsx